<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <md-datepicker
      @input="dateChanged"
      :class="messageClass"
      v-model="saveData.value"
      :required="saveData.required === true ? 'required' : null"
      :md-disabled-dates="disabledDates"
    >
      <label>{{ saveData.label | token_replace(nid)}}</label>
      <span class="md-helper-text">{{ saveData.help_text | token_replace(nid)}}</span>
      <span class="md-error">*Required.</span>
    </md-datepicker>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Date'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <md-datepicker v-model="saveData.value" :md-disabled-dates="disabledDates">
        <label>{{ saveData.label | token_replace(nid)}}</label>
        <span class="md-helper-text">{{ saveData.help_text | token_replace(nid)}}</span>
      </md-datepicker>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-datepicker v-model="tempData.value">
          <label>Value</label>
        </md-datepicker>
        <md-field>
          <label>Help Text</label>
          <md-input v-model="tempData.help_text"></md-input>
        </md-field>
        <md-datepicker v-model="tempData.min">
          <label>Min</label>
        </md-datepicker>
        <md-datepicker v-model="tempData.max">
          <label>Max</label>
        </md-datepicker>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "./FbElementMixin";

export default {
  name: "FbDate",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  created() {
    this.$material.locale.dateFormat = "MMM, dd yyyy";
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.saveData.value = new Date(this.saveData.value);
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(this.saveData.required === true &&
              (!this.saveData.value || this.saveData.value == ""));
      return val;
    },
    value() {
      if (this.valid) {
        let data = new Date(this.saveData.value);
        if (!this.saveData.value || this.saveData.value == "") {
          data = "";
        }
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: data.toString(),
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  data() {
    return {
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || "",
        min: this.element.data.min || "",
        max: this.element.data.max || "",
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || false
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || "",
        min: this.element.data.min || "",
        max: this.element.data.max || "",
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || false
      }
    };
  },
  methods: {
    dateChanged(event) {},
    disabledDates(date) {
      let minDate = new Date(this.saveData.min.toString());
      let maxDate = new Date(this.saveData.max.toString());
      let curDate = new Date(date.toString());
      return date < minDate || date > maxDate;

    }
  },
  watch: {
    "saveData.value": function value() {
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    }
  }
};
</script>
